<!-- <div style=""> -->
    <!-- <div> -->
<mat-dialog-content>
        <h1 style="font-weight: 600;">Veröffentlichung und Lizenzierung des Produkts</h1>
        <form #form="ngForm">
            <!-- Origin_Listing -->
            <div *ngIf="activeListing" style="margin-bottom: 24px;">
                <h3>Verwendetes Abonnement</h3>
                <mat-card class="license-card" style="padding: 16px 20px; box-sizing: border-box;">
                    <div class="card-header">
                        <div class="package-info">
                            <div class="package-number">{{ activeListing.originListing.packageName }}</div>
                            <!-- <div class="date-range">{{ activeListing.originListing.currentUsage }} / {{ activeListing.originListing.listingCapacity }} Verwendete Lizenzen</div> -->
                        </div>
                    </div>

                    <div class="expand-icon" style="display: flex;  justify-content: space-between;">
                        <div style="font-size: 16px;">{{ product.name }}</div>
                        <button style="justify-self: left" color="warn" mat-raised-button (click)="removeEntry()">
                            Lizenzzuordnung entfernen
                        </button>
                    </div>
                </mat-card>

                <!-- Prio_Listing -->
                <mat-card *ngIf="activeListing.prioListing !== null &&
                    (isPrioritized ||
                    activeListing.prioListing.currentUsage < activeListing.prioListing.listingCapacity)" class="license-card"
                    style="padding: 16px 20px; box-sizing: border-box;">
                    <div class="card-header">
                        <div class="package-info">
                            <div class="package-number">Priorisierung</div>
                            <!-- <div class="date-range">{{ activeListing.prioListing.currentUsage }} / {{ activeListing.prioListing.listingCapacity }} Verwendete Lizenzen</div> -->
                        </div>
                    </div>

                    <div class="expand-icon" style="display: flex;  justify-content: space-between;">
                        <div>{{ product.name }}</div>
                        <button style="justify-self: left" [class.green-confirm]="!isPrioritized" [color]="isPrioritized ? 'warn' : undefined" mat-raised-button (click)="isPrioritized
                  ? removePriorization(activeListing.originListing.subscriptionId)
                  : addPriorization(activeListing.originListing.subscriptionId)">
                            {{ isPrioritized ? 'Nicht mehr priorisieren' : 'Priorisieren' }}
                        </button>
                    </div>
                </mat-card>
            </div>

            <div>
                <mat-form-field style="width: 100%">
                    <mat-label>Verfügbare Abonnements</mat-label>
                    <mat-select [ngModel]="selectedGrantOptions" name="authGrantTypes"
                        (ngModelChange)="onGrantSelection($event)"
                        panelClass="custom-select-panel">
                        <mat-option *ngFor="let option of productFromListing"
                            [value]="option.originListing.subscriptionId"><strong>{{ option.originListing.packageName
                                }}</strong> &nbsp;&nbsp;&nbsp; - &nbsp;&nbsp;&nbsp;{{
                            option.originListing.currentUsage}}/{{option.originListing.listingCapacity}} Verwendete
                            Lizenzen</mat-option>
                        <mat-option (click)="showTarifeSelectionDialog()">
                            <mat-icon> add </mat-icon>
                            <strong>{{ 'Neuen Tarif hinzufügen' }}</strong>
                        </mat-option>
                    </mat-select>
                </mat-form-field>
                <br />
            </div>

            <div style="margin-top: 20px;" class="grid">
                <button mat-raised-button color="warn" (click)="onCancel()">
                    {{ activeListing && !selectedGrantOptions ? 'Schließen' : 'Abbrechen' }}
                </button>
                @if(activeListing && selectedGrantOptions) {
                    <button mat-raised-button class="green-confirm" [disabled]="selectedGrantOptions === ''" (click)="onSave()">
                        Wechseln
                    </button>
                } @else if (!activeListing) {
                    <button mat-raised-button class="green-confirm" [disabled]="selectedGrantOptions === ''" (click)="onSave()">
                        Veröffentlichen
                    </button>
                }
            </div>
        </form>
</mat-dialog-content>
    <!-- </div> -->
<!-- </div> -->

<div *ngIf="loading" class="loading-overlay-spinner">
    <mat-spinner></mat-spinner>
</div>